<template>
  <v-flex xs12 row>

    <v-card v-if="invoice">
      <v-card-title>
        <v-flex xs12 class="text-xs-center">
          <img :src="brand.logo">
          <div class="headline text-uppercase" v-text="printTitle"></div>
        </v-flex>
      </v-card-title>

      <v-card-text>
        <v-container grid-list-md>
          
          <v-layout wrap>
            
            <v-flex xs6>
              
              <div v-if="invoice.type == config.invoiceTypes.customer">
                <div class="subheading text-uppercase">
                  <span>Customer</span>
                </div>
                <div class="py-2 px-3">
                  <div class="body-1">{{invoice.customer.title}}</div>
                  <div class="caption" v-if="invoice.customer.address1">{{invoice.customer.address1}}</div>
                  <div class="caption" v-if="invoice.customer.address2">{{invoice.customer.address2}}</div>
                  <div class="caption">{{invoice.customer.mobile}}</div>
                </div>
              </div>

              <div v-else>
                <div class="subheading text-uppercase">
                  <span>Franchisee/Showroom</span>
                </div>
                <div class="py-2 px-3">
                  <div class="body-1">{{invoice.franchisee.title}}</div>
                  <div class="caption">{{invoice.franchisee.phone}}</div>
                </div>
              </div>

            </v-flex>

            <v-flex xs6 class="text-xs-right">
              <div class="subheading text-uppercase">
                <span>{{invoice.code}}</span>
              </div>
              <div class="body-2 py-1">
                <span>Date: </span>
                <span>{{invoice.date}}</span>
              </div>
              <div v-if="invoice.type == config.invoiceTypes.customer">
                <div class="py-1">
                  <div class="body-1">{{invoice.retailer.title}}</div>
                </div>
              </div>

              <div class="caption">
                <span>Biller: {{invoice.biller_name}}</span>
              </div>

            </v-flex>

          </v-layout>

        </v-container>
        <v-divider></v-divider>
        <v-container>
          <v-layout wrap>
            <v-flex xs12>
              <div>
                <div class="v-table__overflow" :class="shrinkClass">
                  <table class="v-datatable v-table">
                    <thead>
                      <tr>
                      	 <th role="columnheader" scope="col" class="column text-xs-left body-2">
                          <span>Sl.</span>
                        </th>
                        <th role="columnheader" scope="col" class="column text-xs-left body-2" v-if="showCode">
                          <span>Item Code</span>
                        </th>
                        <th role="columnheader" scope="col" class="column text-xs-left body-2">
                          <span>Item Name</span>
                        </th>
                        <th role="columnheader" scope="col" class="column text-xs-left body-2">
                          <span>Unit</span>
                        </th>
                        <th role="columnheader" scope="col" class="column text-xs-right body-2" v-if="showPrice">
                          <span>Rate ({{currency}})</span>
                        </th>
                        <th role="columnheader" scope="col" class="column text-xs-right body-2">
                          <span>QTY</span>
                        </th>
                        <th role="columnheader" scope="col" class="column text-xs-right body-2" v-if="showPrice && showTax">
                          <span>Tax (%)</span>
                        </th>
                        <th role="columnheader" scope="col" class="column text-xs-right body-2" v-if="showPrice">
                          <span>Amount ({{currency}})</span>
                        </th>
                      </tr>
                    </thead>
                    <tbody v-if="invoice.items && invoice.items.length > 0">
                      <tr is="invoice-item" v-for="(item, index) in invoice.items" v-bind:item="item" v-bind:index="index" viewMode="true" :showPrice="showPrice" :showCode="showCode" :showTax="showTax"></tr>
                    </tbody>
                    <tbody v-else>
                      <tr>
                        <td colspan="8">No Items Added</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </v-flex>
            <v-flex xs8 v-if="showPrice">
              <v-layout class="align-start justify-end column fill-height pr-3 pb-4">
                <div class="body-2" v-if="amountInWords">
                  <span>Total Amount (In Words): </span>
                  <span class="font-weight-light">{{amountInWords}}</span>
                </div>
                <div class="body-2" v-if="invoice.extra_discount > 0">
                  <span class="grey--text text--darken-2">Extra Discount Narration: </span>
                  <span class="font-weight-light">{{extraDiscountNarration}}</span>
                </div>
              </v-layout>
            </v-flex>
            <v-flex xs4 class="text-xs-right justify-end pr-1 py-3 pr-3" v-if="showPrice">
              <table class="total-table">
                <tbody>
                  <tr class="body-2">
                    <td width="60%">Subtotal: </td>
                    <td width="40%">{{ invoice.subtotal | roundValue}}</td>
                  </tr>
                  <tr class="body-1">
                    <td>Discount (<span>{{invoice.discount_percent}}</span>%): </td>
                    <td><span v-if="invoice.discount > 0">-</span>{{invoice.discount | roundValue}}</td>
                  </tr>
                  <tr class="body-1" v-if="invoice.extra_discount > 0">
                    <td>Extra Discount (<span>{{ invoice.extra_discount_percent }}</span>%):</td>
                    <td><span>-</span>{{ invoice.extra_discount | roundValue }}</td>
                  </tr>
                  <tr class="body-1" v-if="invoice.round_off != 0">
                    <td>Roundoff: </td>
                    <td>{{invoice.round_off | roundValue}}</td>
                  </tr>
                  <tr class="subheading font-weight-medium" v-if="invoice.tax > 0">
                    <td>Total Amount: </td>
                    <td>{{ invoice.total | roundValue}}</td>
                  </tr>
                  <tr class="body-1 font-weight-medium" v-if="invoice.tax > 0">
                    <td width="66%">GST ({{ invoice.tax_percent }}%): </td>
                    <td width="34%">{{ invoice.tax | roundValue }}</td>
                  </tr>
                  <tr class="subheading font-weight-medium">
                    <td width="66%">Grand Total ({{currency}}): </td>
                    <td width="34%">{{ invoice.grandtotal | roundValue }}</td>
                  </tr>
                </tbody>
              </table>
            </v-flex>
          </v-layout>
        </v-container>
        <v-divider></v-divider>
        <v-container>
          <v-layout wrap>
            <v-flex xs8>
              <div v-if="$options.notes && $options.notes.length">
                <div class="body-2">Notes:</div>
                  <ul>
                    <li v-for="(note, index) in $options.notes" :key="`note-${index}`">{{ note }}</li>
                  </ul>
              </div>
            </v-flex>
            <v-flex xs4 class="text-xs-right">
              <div class="body-2 py-2 pb-4 text-capitalize">For {{ brand.title }}:</div>
              <div class="body-2 pt-4">(Authorised Signatory)</div>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card-text>

    </v-card>
    
  </v-flex>
</template>

<script>
  
  import notes from '../config/print-notes'
  import InvoiceItem from './InvoiceItem'

  export default {
    name: 'PrintInvoice',
    props: {
      showPrice: {
        default: true
      },
      showCode: {
        default: true
      },
      showTax: {
        default: true
      }
    },

    data () {
      return {
      	processing: false,
        invoice: null,
        extra_discounts: [],
      }
    },

    created () {
      this.$options.notes = notes
    },

    mounted () {

      this.getAllData('extradiscount')
        .then((response) => {
            
            this.extra_discounts = response

            if (this.$route.params.invoiceCode) {
              this.loadInvoice(this.$route.params.invoiceCode)
              let date = new Date()
              this.setPageTitle(`${this.$route.params.invoiceCode}-${date.getTime()}`)
            }

        })
      
    },

    methods: {

      calculateItemTotal (item) {
        return item.quantity * ( item.rate + ( ( item.rate * item.tax_percent ) / 100) )
      },

      loadInvoice (invoiceCode) {
        this.processing = true
        this.axios.get(this.config.apis.getInvoice.replace(":code", invoiceCode))
          .then((response) => {
            this.processing = false
            if (this.isSuccessResponse(response)) {
              this.invoice = response.data.data
              setTimeout(window.print, 1000)
            }
          })
          .catch((error) => {
            this.processing = false
          })
      },

      setPageTitle (title) {
        document.title = title
      }

    },

    computed: {

      shrinkClass () {
        let class_name = null
        
        if (this.invoice && this.invoice.items) {
          let length = this.invoice.items.length
          if (length > 8) {
            class_name = "xs"
          }
          if (length > 10) {
            class_name = "sm"
          }
          if (length > 12) {
            class_name = "md"
          }
          if (length > 14) {
            class_name = "lg"
          }
        }

        return class_name ? `shrink-${class_name}` : ""

      },

      amountInWords () {
        return this.amountToWords(this.invoice.grandtotal)
      },

      isPending () {
        return this.invoice.status == this.config.invoiceStatus.pending
      },

      isConfirmed () {
        return this.invoice.status == this.config.invoiceStatus.confirmed
      },

      brand () {
      	let brand = this.config.brands.eurotech
      	if (this.invoice && this.invoice.items && this.invoice.items.length > 0) {
          brand = this.invoice.items[0].brand_id == this.config.brands.hanbaz.id ? this.config.brands.hanbaz : brand
        }
        return brand
      },

      printTitle () {
      	return this.isPending || this.isConfirmed ? 'Proforma Invoice' : (this.showPrice ? 'Sales Order' : 'Order Request')
      },

      extraDiscountNarration () {
        
        if (!this.invoice || !this.invoice.extra_discount_ref_id) return ""

        let narration = ""
        let discount = this.extra_discounts.filter( item => item.id === this.invoice.extra_discount_ref_id )

        if (discount.length > 0) {
          narration = discount[0].title
        }
        return narration
      },

    },

    watch: {

      '$route' (to, from) {
        // react to route changes...
        if (to !== from && to.params.invoiceCode) {
          this.loadInvoice(to.params.invoiceCode)
          this.setPageTitle(`${this.$route.params.invoiceCode}-${date.getTime()}`)
        }

      }

    },
    
    components: {
      'invoice-item': InvoiceItem,
    }

  }
</script>
